<template>
    <div class="search-result">
        <a class="result-item" v-for="(result, index) in results" :key="index" @click="selectResult(result)">
            <div class="item-image" 
                :class="{small: !hasImage(result)}" 
                :style="{backgroundImage: `url(${getImageURL(result)})`}"></div>
            <span>{{result.type === 'lamp' ? result.material_description : result.product_description}}</span>
        </a>

        <h4 class="results-count-title" > 
            {{ $t( showTotalResults ? 'results_shown' : 'results') }}: {{results.length}}
            <br>
            <small v-if="showTotalResults">{{ $t('results_specify') }}</small>
        </h4>
    </div>
</template>

<script>
    import { getImageURL, hasImage } from "@/services/utils";

    export default {
        name: "searchResultOverview",
        computed: {
            results() {
                return this.$store.state.search.searchResults;
            },
            resultsAmount() {
                return this.$store.state.search.resultsAmount;
            },
            showTotalResults() {
                return this.resultsAmount > 10 && this.results.length === 10;
            }
        },
        methods: {
            selectResult(result) {
                this.$store.dispatch("search/getMatches", result);
            },

            getImageURL(product) {
                return getImageURL(product);
            },

            hasImage(product) {
                return hasImage(product);
            }
        }
    };
</script>

<style lang="scss" scoped>
  .search-result {
    flex-grow: 1;

      .spinner {
          color: $dark-gray;
          margin-left: 5px;
      }

    .results-count-title {
      padding: 0 0 1rem 0;
      color: $dark-gray;
    }

    .result-item {
      display: flex;
      align-items: center;
      margin-bottom: 28px;

      font-size: $nc-fsz-normal;
      font-weight: bold;

      cursor: pointer;

      img {
        margin-right: 20px;
        box-sizing: border-box;
        border: $nc-gray-border;
        height: 61px;
        width: 61px;
      }

      .item-image {
        margin-right: 20px;
        border: $nc-gray-border;
        height: 61px;
        width: 61px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;

        &.small {
          background-size: 80%;
        }
      }


      &:hover {
        color: $nc-blue-primary;

        img {
          border: 1px solid $nc-blue-primary;
        }
      }
    }
  }
</style>
